//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";
import util from '@/lib/util';

export default {
  name: "user",
  components: {
    BottomNav,
  },
  data() {
    return {
      msg: '',
      member: {
        memberLevelStr: ''
      },
      downloadUrl: util.ApiUrl + 'file/download/',
    }
  },
  computed: {
    isReload() {
      return this.$store.state.app.isReload;
    }
  },
  methods: {
    //  提示弹出框
    TipDialog() {
      this.$dialog.alert({
        // title:'标题呀',
        message: '对不起，您是非业主，需业主才能查看'
      }).then(() => {
        console.log('点击了确认')
      })
    },
    async getMyMember() {
      this.$toast.loading({
        duration: 0,
        message: ''
      });
      await this.$store.dispatch({
        type: 'member/getMyMember'
      }).then(() => {
        this.member = this.$store.state.member.memberInfo;
        localStorage.setItem('MemberId', this.member.id);
      }).finally(() => {
        this.$toast.clear();
      });
    },
    certificate() {
      if (JSON.stringify(this.member) === '{}' || this.member == null || this.member == undefined) {
        // this.$toast("已认证1");
        return
      }
      if (this.member.isAuthentication) {
        //this.$toast.success("已认证");
        this.$router.push({
          name: 'my-houses',
        });
        return
      }
      this.$router.push({path: '/character'})
    },
    myCoupon() {
      this.$router.push({path: '/my-coupon'})
    },
    myHouses() {
      this.$router.push({path: '/my-houses'})
    },
    myIntegral() {
      this.$router.push({path: '/my-integral'})
    }
  },
  created() {
    if (this.isReload) {
      this.$store.commit('app/logout', this)
      abp.auth.clearToken();
      window.location.reload()
    }
    this.getMyMember();
  }
};
